import React, { useState } from 'react';
import FileViewerModal from './FileViewerModal';
import { downloadAuthenticatedFile } from '../utils/authenticatedFile';

type AuthenticatedFileButtonProps = Omit<React.ButtonHTMLAttributes<HTMLButtonElement>, 'onClick'> & {
  url: string;
  fileName: string;
  mimeType?: string | null;
  subtitle?: React.ReactNode;
  action?: 'view' | 'download';
  onError?: (error: unknown) => void;
};

const AuthenticatedFileButton: React.FC<AuthenticatedFileButtonProps> = ({
  url,
  fileName,
  mimeType,
  subtitle,
  action = 'view',
  onError,
  children,
  disabled,
  ...buttonProps
}) => {
  const [viewerOpen, setViewerOpen] = useState(false);
  const [downloading, setDownloading] = useState(false);

  const handleClick = async () => {
    if (action === 'view') {
      setViewerOpen(true);
      return;
    }

    try {
      setDownloading(true);
      await downloadAuthenticatedFile(url, fileName);
    } catch (error) {
      console.error('Não foi possível baixar o arquivo protegido.', error);
      onError?.(error);
    } finally {
      setDownloading(false);
    }
  };

  return (
    <>
      <button
        {...buttonProps}
        type="button"
        disabled={disabled || downloading}
        aria-busy={downloading || undefined}
        onClick={handleClick}
      >
        {children}
      </button>

      {viewerOpen && (
        <FileViewerModal
          url={url}
          nome={fileName}
          mimeType={mimeType}
          subtitle={subtitle}
          onClose={() => setViewerOpen(false)}
        />
      )}
    </>
  );
};

export default AuthenticatedFileButton;
